import styled from "@emotion/styled"
import { Grid } from "@mui/material"

export const StyledPageHeader = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  "@media (min-width: 992px)": {
    flexDirection: "row"
  },
  "& > div:nth-child(1)": {
    flexGrow: 1
  },
  "& > div:nth-child(2)": {
    display: "flex",
    marginTop: "16px",
    "@media (min-width: 992px)": {
      justifyContent: "flex-end",
      marginTop: 0
    }
  }
})
